import { COMMUNITY_DASHBOARD_FILTER_TYPE, USER_PROPERTIES } from './constants';

export default (
  innerAppliedFilters,
  appliedFilters,
  profileAttributeQuotaRequired
) => {
  let filterDifferences = false;

  if (appliedFilters.length === 0 && innerAppliedFilters.length === 0) {
    return false;
  }

  for (let i = 0; i < innerAppliedFilters.length; i += 1) {
    const iAF = innerAppliedFilters[i];

    if (iAF.type === COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG) {
      if (!iAF.tags.category || iAF.tags.category === '') {
        filterDifferences = true;
        break;
      }

      if (!iAF.tags.tagName || iAF.tags.tagName === '') {
        filterDifferences = true;
        break;
      }

      if (
        !iAF.tags.tagValue ||
        iAF.tags.tagValue === '' ||
        (Array.isArray(iAF.tags.tagValue) && !iAF.tags.tagValue.length)
      ) {
        filterDifferences = true;
        break;
      }

      if (profileAttributeQuotaRequired && !iAF.tags.quota) {
        filterDifferences = true;
        break;
      }
    }

    if (iAF.type === COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY) {
      if (
        !iAF.userProperties.propertyName ||
        iAF.userProperties.propertyName === ''
      ) {
        filterDifferences = true;
        break;
      }

      if (
        !iAF.userProperties.propertyValue ||
        iAF.userProperties.propertyValue === '' ||
        (Array.isArray(iAF.userProperties.propertyValue) &&
          !iAF.userProperties.propertyValue.length)
      ) {
        filterDifferences = true;
        break;
      }

      if (
        profileAttributeQuotaRequired &&
        !iAF.userProperties.quota &&
        ![
          USER_PROPERTIES.AGE,
          USER_PROPERTIES.GENDER,
          USER_PROPERTIES.LANGUAGE
        ].includes(iAF.userProperties.propertyName)
      ) {
        filterDifferences = true;
        break;
      }
    }

    if (iAF.type === COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY) {
      if (
        !iAF.community.name ||
        iAF.community.name === '' ||
        (Array.isArray(iAF.community.name) && !iAF.community.name.length)
      ) {
        filterDifferences = true;
        break;
      }
    }
  }

  return !filterDifferences;
};
